import React from "react";

function SportsFeature() {
  return (
    <div>
      <section className="sports-feature">
        <div className="container-fluid p-0">
          <div className="row g-0 align-items-stretch">
            <div className="col-12 col-lg-6">
              <div className="sports-feature-content">
                <h2 className="sports-feature-title futuraPTBold">
                  Where Every Game
                  <br />
                  Becomes an Unforgettable
                </h2>

                <p className="sports-feature-text">
                  From the opening whistle to the final celebration, ADS Sports
                  Complex is where athletes compete, families connect, and
                  unforgettable moments come to life. Our state-of-the-art facilities
                  host premier tournaments, league play, championship events, and
                  community competitions for all ages and skill levels. Whether
                  you’re stepping onto the court, cheering from the sidelines, or
                  celebrating a hard-earned victory, every event is designed to
                  deliver excitement, sportsmanship, and memories that last long
                  after the final score.
                </p>

                <div className="row g-4 sports-programs">
                  <div className="col-12 col-sm-6">
                    <div className="sports-program">
                      <h3>Volleyball</h3>
                      <p>
                        Camps, Clinics
                        <br />
                        and Tournaments
                      </p>

                      <a href="/volleyball" className="btn sports-program-button">
                        Volleyball Signup
                      </a>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6">
                    <div className="sports-program">
                      <h3>Basketball</h3>
                      <p>
                        Camps &amp; Clinics
                      </p>
                      <br />
                      <a href="/basketball" className="btn sports-program-button">
                        Basketball Signup
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="sports-feature-image">
                <img
                  src="/s3/youth-sports-team.jpg"
                  alt="Young athletes joining hands together"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
  ;
}

export default SportsFeature;
